import React, { useState } from "react";
import CardImg from "../../../components/CardImg";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import VBetTableTrio from "../../casinoComponents/betTableTrio/VBetTableTrio";
import { getCardImage } from "../../casinoComponents/resultVisuals/cardAssets";
import TrioRefResults from "../resultui/resultTrio/TrioRefResults";
import { IS_REF_MOBILE } from "../../../utils/refViewport";
import { latestBets } from "../../../utils/casinoMyBets";
import { formatOdds, formatAmount } from "../../../utils/formatOdds";
import { getCasinoRulesHtml } from "../../../data/casinoRulesHtml";

function formatBetDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

// Reference vcasino RightSideBar: My Bets card with the 3-column (UserName / Rate / Amount) table
function VRightSide({ bets = [], onViewMore }) {
  const list = latestBets(bets); // latest 10, like the reference
  return (
    <div className="card m-b-10 my-bet" id={IS_REF_MOBILE ? "casino-bets" : undefined}>
      <div className="card-header">
        <h6 className="card-title float-left">My Bets</h6>{" "}
        <a
          href="javascript:void(0)"
          className="btn btn-back float-right"
          onClick={(e) => {
            e.preventDefault();
            if (typeof onViewMore === "function") onViewMore();
          }}
        >
          View More
        </a>
      </div>{" "}
      <div className="card-body1">
        <div className="tab-content">
          <div id="matched-bet" className="tab-pane active">
            <div className="table-responsive1">
              <table className="table coupon-table table-striped mb-0">
                <thead>
                  <tr>
                    <th style={{ minWidth: "90px" }}>UserName</th>
                    <th className="text-right" style={{ minWidth: "50px" }}>Rate</th>
                    <th className="text-right" style={{ minWidth: "70px" }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {list.length === 0 ? (
                    <tr>
                      <td colSpan={4} className="text-center">No records found</td>
                    </tr>
                  ) : (
                    list.map((bet, i) => {
                      const t = String(bet.type || bet.gametype || "").toLowerCase();
                      const border = t === "lay" ? "lay-border" : t === "back" ? "back-border" : undefined;
                      return (
                        <React.Fragment key={bet.id || i}>
                          <tr className={border}>
                            <td colSpan={4}>
                              <b>{bet.selection || bet.matchedBet || "-"}</b>{" "}
                              <span className="float-right">{formatBetDate(bet.placeDate)}</span>
                            </td>
                          </tr>
                          <tr className={border}>
                            <td>{bet.userName}</td>
                            <td className="text-right">{formatOdds(bet.odds)}</td>
                            <td className="text-right">{formatAmount(bet.stake)}</td>
                          </tr>
                          <tr>
                            <td colSpan={4} style={{ height: "3px", padding: 0 }} />
                          </tr>
                        </React.Fragment>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * V-Trio (vcasino/trio, API type vtrio) in the reference markup:
 *   .casino-table.vcasino.vtrio >
 *     [.progress.mobile-timer (ft > 3)]
 *     .casino-video > .casino-video-title + .video-box-container + .vcasino-cards (3 cards) + right icons (home, rules)
 *     .casino-detail > .main-odds + .other-odds + .sub-odds + .casino-video-last-results
 */
export default function VTrioView({ gameName, title, data, exposures = {}, onBetClick, myBets, onViewMore, viewMoreModal }) {
  const [showRules, setShowRules] = useState(false);
  const [showRulesModal, setShowRulesModal] = useState(false);
  const rulesHtml = getCasinoRulesHtml(gameName) || "";
  const cards = data?.card ? String(data.card).split(",") : [];
  const ft = Number(data?.ft) || 0;
  const lt = Number(data?.lt) || 0;

  return (
    <CasinoTableLayout tableClass="vcasino vtrio" rightSide={<VRightSide bets={myBets} onViewMore={onViewMore} />}>
      <>
        {ft > 3 && (
          <div className="progress mobile-timer">
            <div
              className={`progress-bar ${lt <= 3 ? "bg-danger" : lt <= 6 ? "bg-warning" : "bg-success"}`}
              style={{ width: `${((100 * lt) / ft).toFixed(2)}%` }}
            />
          </div>
        )}{" "}
        <div className="casino-video">
          <div className="casino-video-title">
            <span className="casino-name">{title}</span>{" "}
            <div className="casino-video-rid">Round ID: {data?.mid}</div>
          </div>{" "}
          <div className="video-box-container">
            <div className="video-box" />
          </div>{" "}
          {cards.length > 0 && (
            <div className="vcasino-cards w-100 text-center">
              {[0, 1, 2].map((i) => (
                <React.Fragment key={i}>
                  {i > 0 && " "}
                  <span>
                    <CardImg src={getCardImage(cards[i])} alt="" />
                  </span>
                </React.Fragment>
              ))}
            </div>
          )}{" "}
          <div className="casino-video-right-icons">
            <div title="Home" className="casino-video-home-icon">
              <Link to="/admin/vcasino/list" style={{ color: "var(--text-highlight)" }}>
                <i className="fas fa-home" />
              </Link>
            </div>{" "}
            <div
              title="Rules"
              className="casino-video-rules-icon"
              onClick={() => {
                setShowRules(true);
                if (IS_REF_MOBILE) setShowRulesModal(true);
              }}
            >
              <i className="fas fa-info-circle" />
            </div>
          </div>{" "}
          <div>
            {showRules && (
              <div
                id="casino-vieo-rules"
                aria-modal="true"
                className="casino-vieo-rules show d-none-small show-rules"
                style={{ display: "block" }}
              >
                <div className="rules-header">
                  <div>Rules</div> <i className="fas fa-times" onClick={() => setShowRules(false)} />
                </div>{" "}
                <div className="rules-body" dangerouslySetInnerHTML={{ __html: rulesHtml }} />
              </div>
            )}
            <Modal
              show={showRulesModal}
              onHide={() => setShowRulesModal(false)}
              className="casino-rules teenpatti2-rule-modal"
              dialogClassName="modal-md"
              id="rules-modal"
            >
              <header className="modal-header">
                <h5 className="modal-title">Rules</h5>{" "}
                <button type="button" aria-label="Close" className="close" onClick={() => setShowRulesModal(false)}>
                  ×
                </button>
              </header>
              <Modal.Body>
                <div className="casino-vieo-rules show-rules show">
                  <div className="rules-body" dangerouslySetInnerHTML={{ __html: rulesHtml }} />
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>{" "}
        {data?.mid ? (
          <div className="casino-detail">
            <VBetTableTrio data={data?.sub} exposures={exposures} onBetClick={onBetClick} />{" "}
            {data?.remark ? (
              <div className="casino-remark mt-3">
                <div className="remark-icon">
                  <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
                </div>{" "}
                <marquee>{data.remark}</marquee>
              </div>
            ) : null}{" "}
            <div className="casino-video-last-results">
              <TrioRefResults gameType={gameName} fallbackTitle={title} roundId={data?.mid} />
            </div>
          </div>
        ) : null}
      </>
      {viewMoreModal}
    </CasinoTableLayout>
  );
}
